import { render, staticRenderFns } from "./bulk-payment-history-list.vue?vue&type=template&id=5ffcd15e&scoped=true"
import script from "./bulk-payment-history-list.vue?vue&type=script&lang=js"
export * from "./bulk-payment-history-list.vue?vue&type=script&lang=js"
import style0 from "./bulk-payment-history-list.vue?vue&type=style&index=0&id=5ffcd15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffcd15e",
  null
  
)

export default component.exports